const CDN_BASE = 'https://cdn.adsalecdn.com/EMP/2-0/License/';

export const BR_LICENSE_ASSETS = {
  /** 过渡期提醒弹窗图标（Figma Doc_Upload） */
  docUploadIcon: `${CDN_BASE}Doc_Upload.png`,
  infoIcon: `${CDN_BASE}info.png`,
  lockIcon: `${CDN_BASE}Lock.png`,
  badgePending: `${CDN_BASE}New_Pending_for_Approval.png`,
  badgeApproved: `${CDN_BASE}New_Approved.png`,
  badgeReady: `${CDN_BASE}New_Approved_ready_to_use.png`,
  badgeStatusAlert: `${CDN_BASE}New_Status_Icon.png`,
  /** 审批通过弹窗图标（Figma Check circle 72×72） */
  docApprovedIcon: `${CDN_BASE}NewVector.svg`,
  docPendingIcon: `${CDN_BASE}Doc_Pending.svg`,
  expirySoonAlertIcon: `${CDN_BASE}Expiry_date.png`,
  /** 驳回弹窗：半红感叹号（Figma Doc_Upload_reject） */
  docUploadRejectIcon: `${CDN_BASE}Doc_Upload_reject.svg`,
  /** 驳回详情页：全红 Doc_Fail */
  docFailIcon: `${CDN_BASE}Doc_Fail.svg`,
  rejectedReasonIcon: `${CDN_BASE}New_RejectedTip.png`,
  /** 管理端编辑模式：卡片右上角 More horiz（Figma） */
  moreHorizIcon: `${CDN_BASE}More_horiz.svg`,
  calendarIcon: 'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Event.svg',
  examples: [
    `${CDN_BASE}example_1.png`,
    `${CDN_BASE}example_2.png`,
    `${CDN_BASE}example_3.png`,
    `${CDN_BASE}example_4.png`,
  ],
};
